export const useGroupFormatters = () => {
    return {
        'criteria.filters\\.\\d+\\.value\\.\\d+': (key, oldValue, newValue, auditRecord) => {
            const entityAuditMapping = auditRecord.params && 'entityAuditMapping' in auditRecord.params ? auditRecord.params.entityAuditMapping : undefined;
            const result = {};
            if (!entityAuditMapping) {
                return { key, oldValue, newValue };
            }
            if (typeof oldValue === 'string') {
                const splitedOldValue = oldValue.split('_');
                if (splitedOldValue.length === 2) {
                    result.oldValue = `${entityAuditMapping[splitedOldValue[0]]}_${splitedOldValue[1]}`;
                }
                else {
                    result.oldValue = oldValue;
                }
            }
            if (typeof newValue === 'string') {
                const splitedNewValue = newValue.split('_');
                if (splitedNewValue.length === 2) {
                    result.newValue = `${entityAuditMapping[splitedNewValue[0]]}_${splitedNewValue[1]}`;
                }
                else {
                    result.newValue = newValue;
                }
            }
            return result;
        },
    };
};
